import { connect } from 'react-redux';

import ActionInputsWrapper from 'app/developer-v3/pages/actions/ActionInputs/ActionInputsWrapper';
import { saveActionInputField } from 'app/developer-v3/Actions';
import {
  currentAction,
  selectIsServiceSetup,
} from 'app/developer-v3/selectors';

const mapStateToProps = state => ({
  action: currentAction(state),
  isActionSetup: selectIsServiceSetup(state),
});

export default connect(mapStateToProps, {
  saveInputField: saveActionInputField,
})(ActionInputsWrapper);
